var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSavedIconEzsheet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-Step-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "83-EZ-Step-3-Save-as-Draft",
    transform: "translate(-32.000000, -653.000000)",
    fill: "#7c7c7c",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(14.000000, 543.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-Destination-Button-Copy-2",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2307692,3.07692308 L19.2307692,2.49855985 C19.2307692,1.97050578 18.5961538,1.53846154 17.8205128,1.53846154 L10.7692308,1.53846154 L10.7692308,2.81859262 L17.8205128,2.81859262 C18.3340812,2.81859262 18.8155427,2.91297029 19.2307692,3.07692308 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5938645,9.53790139 C16.9635531,9.53790139 18.2260531,9.99889326 19.2307692,10.7716249 L19.2307692,5.87250785 C19.2307692,5.12715109 18.6126374,4.51731373 17.8571429,4.51731373 L9.61538462,4.51731373 L9.61538462,1.35519412 C9.61538462,0.609837354 8.99725275,-7.28306304e-14 8.24175824,-7.28306304e-14 L1.37362637,-7.28306304e-14 C0.618131868,-7.28306304e-14 -1.67865721e-12,0.609837354 -1.67865721e-12,1.35519412 L-1.67865721e-12,15.3846154 L9.66762821,15.3846154 C9.66762821,12.1606989 12.3260989,9.53790139 15.5938645,9.53790139 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3846154,10.7692308 C12.8397249,10.7692308 10.7692308,12.8396889 10.7692308,15.3846386 C10.7692308,17.9295883 12.8397249,20 15.3846154,20 C17.9295523,20 20,17.9295419 20,15.3845922 C20,12.8396425 17.9295523,10.7692308 15.3846154,10.7692308 Z M17.6923077,15.6566604 L15.6566604,15.6566604 L15.6566604,17.6923077 L14.3433396,17.6923077 L14.3433396,15.6566604 L12.3076923,15.6566604 L12.3076923,14.3433396 L14.3433396,14.3433396 L14.3433396,12.3076923 L15.6566604,12.3076923 L15.6566604,14.3433396 L17.6923077,14.3433396 L17.6923077,15.6566604 Z",
    id: "Shape"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedIconEzsheet);
export default __webpack_public_path__ + "static/media/saved-icon-ezsheet.cd17f2f8b7741b59078a32b4d1955dc9.svg";
export { ForwardRef as ReactComponent };